import React, { FC } from "react";
import RouteListItem from "./RouteListItem";

// MUI
import List from "@mui/material/List";

import { RoutePoint } from "../PublicPage/SidebarPanes/PublicRoutesPane";

export type RouteListProps = {
  items: RoutePoint[];
  readOnly?: boolean;
  handleDeleteItem:(indexToDelete: number) => void;
};

const RouteList: FC<RouteListProps> = (props) => {

  const { items, readOnly, handleDeleteItem } = props;

  return (
    <List>
      {items.map((item, index) => (
        <RouteListItem
          handleDeleteItem={handleDeleteItem}
          item={item}
          index={index}
          key={item.uuid}
          readOnly={readOnly}
        />
      ))}
    </List>
  );
}

export default RouteList;
